<template>
  <el-dialog title="合同续签" :visible.sync="syncVisible" width="620px" @close="onClose">
    <div style="background:#f5f7fa;padding:10px 12px;border-radius:8px;margin-bottom:16px;font-size:13px;color:#606266">{{ renewInfo }}</div>
    <el-form :model="renewForm" label-width="120px">
      <el-row :gutter="12">
        <el-col :span="12">
          <el-form-item label="新合同开始日">
            <el-date-picker v-model="renewForm.startDate" type="date" format="yyyy-MM-dd" style="width:100%" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="新合同结束日">
            <el-date-picker v-model="renewForm.endDate" type="date" format="yyyy-MM-dd" style="width:100%" :disabled="renewEndDisabled" />
            <div v-if="renewEndHint" style="color:#999;font-size:12px;line-height:1.4;margin-top:4px">{{ renewEndHint }}</div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="12">
        <el-col :span="12">
          <el-form-item label="合同类型">
            <el-select v-model="renewForm.contractTypeName" placeholder="请选择" style="width:100%" @change="renewSyncType">
              <el-option v-for="t in typeOptions" :key="t" :label="t" :value="t" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="新合同编号">
            <el-input v-model="renewForm.contractNo" placeholder="自动生成" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注">
        <el-input v-model="renewForm.remark" type="textarea" :rows="2" placeholder="可选，如：续签一期 / 转无固定期限" />
      </el-form-item>
      <el-form-item label="续签附件">
        <upload :item="renewUploadObj" :defaultFileList="parseFileList(renewForm.attachment)"
          @dataFile="(fileList) => renewForm.attachment = fileList" />
        <div style="color:#999;font-size:12px;margin-top:4px">支持任意格式，可多选</div>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="syncVisible = false">取消</el-button>
      <el-button type="primary" @click="submitRenew">确认续签</el-button>
    </div>
  </el-dialog>
</template>

<script>
import upload from '@/components/upload/index.vue'
import { renewLaborContractApi } from '@/api/laborContract/index'

export default {
  name: 'RenewDialog',
  components: { upload },
  props: {
    row: { type: Object, default: null },
    visible: { type: Boolean, default: false }
  },
  data() {
    return {
      renewInfo: '',
      renewForm: this.emptyRenewForm(),
      renewUploadObj: {
        key: 'attachment',
        uploadType: 'project',
        accept: '*',
        limit: 10,
        fileMaxSize: 200,
        disabled: false
      },
      typeOptions: ['固定期限', '无固定期限', '实习协议', '劳务协议', '以完成一定工作任务为期限']
    }
  },
  computed: {
    syncVisible: {
      get() { return this.visible },
      set(v) { this.$emit('update:visible', v) }
    },
    renewEndDisabled() {
      return this.renewForm.contractTypeName === '无固定期限'
    },
    renewEndHint() {
      if (this.renewForm.contractTypeName === '无固定期限') return '无固定期限合同无到期日，不纳入到期提醒'
      if (this.renewForm.contractTypeName === '以完成一定工作任务为期限') return '以完成任务为期限：可填「预计完成日」用于到期提醒，留空则不提醒'
      return ''
    }
  },
  watch: {
    visible(v) {
      if (v) this.init()
    }
  },
  methods: {
    emptyRenewForm() {
      return {
        contractNo: '', contractTypeName: '', contractTypeCode: '', startDate: null, endDate: null,
        remark: '', attachment: '', remindDays: null, sourceContractId: null
      }
    },
    fmt(date) {
      if (!date) return null
      const d = date instanceof Date ? date : new Date(date)
      const p = n => (n < 10 ? '0' + n : '' + n)
      return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
    },
    toDate(str) {
      if (!str) return null
      const d = new Date(str + 'T00:00:00')
      return isNaN(d.getTime()) ? null : d
    },
    parseFileList(val) {
      if (!val) return []
      let arr = val
      if (typeof val === 'string') {
        try { arr = JSON.parse(val) } catch (e) { return [] }
      }
      if (!Array.isArray(arr)) return []
      return arr
    },
    init() {
      const row = this.row
      if (!row) return
      this.renewInfo = `为 ${row.employeeName}（${row.dept || ''} · ${row.post || ''}）续签 · 原合同号 ${row.contractNo || ''}，到期日 ${row.endDate || '—'}`
      const pad = n => (n < 10 ? '0' + n : '' + n)
      const toStr = d => d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate())
      const shift = (str, days) => {
        const d = new Date((str || toStr(new Date())) + 'T00:00:00')
        d.setDate(d.getDate() + days)
        return toStr(d)
      }
      const shiftYear = (str, years) => {
        const d = new Date((str || toStr(new Date())) + 'T00:00:00')
        d.setFullYear(d.getFullYear() + years)
        return toStr(d)
      }
      const start = row.endDate ? shift(row.endDate, 1) : toStr(new Date())
      this.renewForm = {
        contractNo: 'HT-' + Date.now(),
        contractTypeName: row.contractTypeName || '',
        contractTypeCode: row.contractTypeCode || '',
        startDate: this.toDate(start),
        endDate: start ? this.toDate(shiftYear(start, 1)) : null,
        remark: '',
        attachment: '',
        remindDays: row.remindDays,
        sourceContractId: row.id
      }
      if (this.renewForm.contractTypeName === '无固定期限') this.renewForm.endDate = null
    },
    renewSyncType(val) {
      this.renewForm.contractTypeName = val
      this.renewForm.contractTypeCode = val
      if (val === '无固定期限') this.renewForm.endDate = null
    },
    submitRenew() {
      const f = this.renewForm
      const type = f.contractTypeName
      if (!type) {
        this.$message.warning('请选择合同类型')
        return
      }
      const requiresEnd = type !== '无固定期限' && type !== '以完成一定工作任务为期限'
      if (!f.startDate) {
        this.$message.warning('请填写新合同开始日')
        return
      }
      if (requiresEnd && !f.endDate) {
        this.$message.warning('「' + type + '」合同需填写结束日期')
        return
      }
      if (!f.contractNo) f.contractNo = 'HT-' + Date.now()
      const payload = {
        contractNo: f.contractNo,
        employeeName: this.row.employeeName,
        dept: this.row.dept,
        post: this.row.post,
        contractTypeName: f.contractTypeName,
        contractTypeCode: f.contractTypeCode,
        startDate: this.fmt(f.startDate),
        endDate: requiresEnd ? this.fmt(f.endDate) : null,
        attachment: f.attachment,
        remark: f.remark,
        remindDays: f.remindDays,
        sourceContractId: this.row.id,
        renewFlag: 1
      }
      renewLaborContractApi(payload).then(res => {
        if (res.code == 200) {
          this.$message.success('续签成功')
          this.syncVisible = false
          this.$emit('success')
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    onClose() {
      this.renewForm = this.emptyRenewForm()
      this.renewInfo = ''
    }
  }
}
</script>
